import React from 'react'
import '../../index.css'
import { Link } from "react-router";
import { Tooltip } from "react-tooltip";
import secondcoming3 from '../../Assets/Img/secondcoming3.jpg'

const Chap13 = () => {
  return (
    <div className="chapter-container">

      <div className="chapterFooter">
          <Link to="/Chap12">Previous</Link>
          <Link to="/">Home</Link>
          <Link to="/Chap14">Next</Link>
      </div>

      <h1 className='chapterHeading'>Chapter 13: Second Coming to the World</h1>

      <img src={secondcoming3} className='image' alt='Christ appearing at second coming' />

    <div className="wrapper">


    <div className='paragraph'>
          <p>For Joseph and the early Mormons, it stood to reason that the end was near. Mormon scriptures declare that the earth will have a temporal existence of 7,000 years. Joseph had convinced the early Mormons that they were living in the end of the sixth thousand-year period (just prior to the year 2000). The Millennium would take place at the beginning of the seventh thousand-year period (around the year 2000).
          </p>
        </div>

        <div className='paragraph'>
          <p>Joseph revealed, “... as God made the world in six days, and on the seventh day he finished his work … in the beginning of 
            the seventh thousand years will the Lord God sanctify the earth.”  
            <btn id="clickable1" className="footnote">1 </btn>
            <Tooltip anchorSelect="#clickable1" className="footnote-size" clickable>D&C 77:6.</Tooltip>
            
            Sanctifying the earth refers to the beginning of the Millennium. Perhaps Joseph gleaned this idea from John in the Book of Revelation. 
            John the Revelator wrote that the earth’s history is divided into seven one-thousand year increments or seven seals. Joseph revealed that John’s seven seals 
            contained “... the works of God; the hidden things of his economy concerning this earth during the seven thousand years of its continuance, or its temporal 
            existence.”
            <btn id="clickable2" className="footnote">2 </btn>
            <Tooltip anchorSelect="#clickable2" className="footnote-size" clickable>D&C 77:12.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Tenth Mormon prophet Joseph Fielding Smith explained of Joseph’s revelation on the Book of Revelation, stating, “Here is a definite statement by revelation to us 
            that this earth will go through 7,000 years of temporal existence.”  
            <btn id="clickable3" className="footnote">3 </btn>
            <Tooltip anchorSelect="#clickable3" className="footnote-size" clickable>Joseph Fielding Smith, Doctrines of Salvation, vol. 1, p. 79-80.</Tooltip>
            
            He also stated, “We have evidence beyond dispute that Adam was driven out of the Garden of Eden about 6,000 years ago, or perhaps a short time less.”
            <btn id="clickable4" className="footnote">4 </btn>
            <Tooltip anchorSelect="#clickable4" className="footnote-size" clickable>Joseph Fielding Smith, Doctrines of Salvation, vol. 1, p. 79.</Tooltip>
          </p>
        </div>

        <h2 className="headlinePadding">Satan and his Hosts Gather at Jerusalem for Final Battle</h2>

        <div className='paragraph'>
          <p>Eventually, Satan and his forces will realize that it is futile to fight against Zion in Jackson County. They will then turn their assault to the Jews in 
            Jerusalem. In 1845, the Mormon apostles published a proclamation to the world stating that Satan, “… will send a great army to Palestine, against the Jews; 
            and they will besiege their city, and will reduce the inhabitants of Jerusalem to the greatest extreme of distress and misery.”  
            <btn id="clickable5" className="footnote">5 </btn>
            <Tooltip anchorSelect="#clickable5" className="footnote-size" clickable>Proclamation Of The Twelve Apostles Of The Church Of Jesus Christ, Of Latter-Day Saints, (New York, 1845), pp. 6-7.</Tooltip>
            
            The Old Testament prophet Daniel referred to this as the “abomination of desolation.” The temple at Jerusalem will be “cast down” and “trodden under foot” 
            2,300 days.
            <btn id="clickable6" className="footnote">6 </btn>
            <Tooltip anchorSelect="#clickable6" className="footnote-size" clickable>Daniel 8:11-14; 11:31; 12:6-11.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>During this period, according to John the Revelator, two prophets will be sent to Jerusalem. “And I will give power unto my two witnesses, and they shall prophesy 
            a thousand two hundred and threescore days (3.5 years), clothed in sackcloth.”  
            <btn id="clickable7" className="footnote">7 </btn>
            <Tooltip anchorSelect="#clickable7" className="footnote-size" clickable>Revelation 11:3.</Tooltip>
            
            Christ will protect these two witnesses. “And if any man will hurt them, fire proceedeth out of their mouth, and devoureth their enemies: and if any man will hurt 
            them, he must in this manner be killed.”
            <btn id="clickable8" className="footnote">8 </btn>
            <Tooltip anchorSelect="#clickable8" className="footnote-size" clickable>Revelation 11:5.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>However, after their mission is complete, they will be killed. “And when they shall have finished their testimony, the beast that ascendeth out of the bottomless 
            pit shall make war against them, and shall overcome them, and kill them.”  
            <btn id="clickable9" className="footnote">9 </btn>
            <Tooltip anchorSelect="#clickable9" className="footnote-size" clickable>Revelation 11:7</Tooltip>
            
            Their bodies will lie in the streets three and one-half days. The wicked will “rejoice over them, and make merry, and shall send gifts one to another.”
            <btn id="clickable10" className="footnote">10 </btn>
            <Tooltip anchorSelect="#clickable10" className="footnote-size"  clickable>Revelation 11:10</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Joseph revealed the identity of the two witnesses. “Q. What is to be understood by the two witnesses, in the eleventh chapter of Revelation? A. They are two 
            prophets that are to be raised up to the Jewish nation in the last days, at the time of the restoration, and to prophesy to the Jews after they are gathered and 
            have built the city of Jerusalem in the land of their fathers.”  
            <btn id="clickable11" className="footnote">11 </btn>
            <Tooltip anchorSelect="#clickable11" className="footnote-size" clickable>D&C 77:15.</Tooltip>
            
            Mormon apostle Bruce McConkie identified the two witnesses as “followers of that humble man Joseph Smith … No doubt they will be members of the Council of the 
            Twelve or of the First Presidency of the Church.”
            <btn id="clickable12" className="footnote">12 </btn>
            <Tooltip anchorSelect="#clickable12" className="footnote-size" clickable>Bruce McConkie, Doctrinal New Testament Commentary, vol. 3, p. 509.</Tooltip> 
          </p>
        </div>

        <h2 className="headlinePadding">Michael, the Archangel, Announces “It is Done”</h2>

        <div className='paragraph'>
          <p>Immediately before Christ’s appearance, Michael, the seventh angel of the harvest, will sound his trump and say to the world, “It is done.”  
          <btn id="clickable13" className="footnote">13 </btn>
          <Tooltip anchorSelect="#clickable13" className="footnote-size" clickable>Revelation 16:17.</Tooltip> 
            
            At this, the powers of heaven will be shaken. “The curtain of heaven” will be unfolded as “a scroll is unfolded after it is rolled up.”  
            <btn id="clickable14" className="footnote">14 </btn>
            <Tooltip anchorSelect="#clickable14" className="footnote-size" clickable>D&C 88:89.</Tooltip>  
            
            This disruption in the earth’s surface will cause earthquakes and all manner of natural disasters.
          </p>
        </div>

        <div className='paragraph'>
          <p>In Joseph Smith Matthew, Jesus states of his coming “… the powers of heaven shall be shaken, then shall appear the sign of the Son of Man in heaven, and ... 
            they shall see the Son of Man coming in the clouds of heaven, with power and great glory.”  
            <btn id="clickable15" className="footnote">15 </btn>
            <Tooltip anchorSelect="#clickable15" className="footnote-size" clickable>Joseph Smith Matthew, 1:36.</Tooltip>  
            
            Joseph spoke regarding Christ’s appearance at his Second Coming as a gradual phenomenon. “How are we to see it? … The dawning of the morning makes its appearance 
            in the east and moves along gradually. So also, will the coming of the Son of Man be. It will be small at its first appearance, and gradually becomes larger until 
            every eye shall see it … It will be small at first and will grow larger and larger until it will be all in a blaze so that every eye shall see it.”
            they shall see the Son of Man coming in the clouds of heaven, with power and great glory.”  
            <btn id="clickable16" className="footnote">16 </btn>
            <Tooltip anchorSelect="#clickable16" className="footnote-size" clickable>Discourse of Joseph Smith at Nauvoo, Illinois, reported in “Journals of James Burgess, 1818-1904,” MS, d, 1858.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>Then, all the world shall see Christ in his glory. Joseph revealed, “The veil of the covering of my temple, in my tabernacle, which hideth the earth, shall be 
            taken off, and all flesh shall see me together.”  
            <btn id="clickable17" className="footnote">17 </btn>
            <Tooltip anchorSelect="#clickable17" className="footnote-size" clickable>D&C 101:23.</Tooltip> 
            
            Joseph revised John’s Book of Revelation vision as, “And the heavens opened as a scroll is opened when it is rolled together; and every mountain, and island, 
            was moved out of its place.”
            <btn id="clickable18" className="footnote">18 </btn>
            <Tooltip anchorSelect="#clickable18" className="footnote-size" clickable>Joseph Smith Translation, Revelation 6:14-16.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>John describes the sight of Christ’s coming as “unquenchable fire”  
          <btn id="clickable19" className="footnote">19 </btn>
          <Tooltip anchorSelect="#clickable19" className="footnote-size" clickable>D&C 63:34.</Tooltip> 
            
            coming to earth, that “the kings of the earth, and the great men, and the rich men, and the chief captains, and the mighty men, and every bond man, and every 
            free man, hid themselves in the dens and in the rocks of the mountain; and said to the mountains and rocks, Fall on us, and hide us from the face of him that 
            sitteth on the throne, and from the wrath of the Lamb.”
            <btn id="clickable20" className="footnote">20 </btn>
            <Tooltip anchorSelect="#clickable20" className="footnote-size" clickable>Joseph Smith Translation, Revelation 6:14-16.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>The brilliance and power of Christ’s glory will defy human power to describe. Joseph revealed, “So great shall be the glory of his presence that the sun shall 
            hide his face in shame and the moon shall withhold its light, and the stars shall be hurled from their places.”  
            <btn id="clickable21" className="footnote">21 </btn>
            <Tooltip anchorSelect="#clickable21" className="footnote-size" clickable>D&C 133:49.</Tooltip> 
            
            As he nears the earth, Christ will sweep the earth as “with the besom of destruction,” and deluge the earth with the fiery floods of his wrath so that the 
            filthiness and abominations of the world will be consumed.  
            <btn id="clickable22" className="footnote">22 </btn>
            <Tooltip anchorSelect="#clickable22" className="footnote-size" clickable>Isaiah 14:23; Malachi 4:1; D&C 29:9; 64:24; 133:64.</Tooltip> 
            
            The brilliance of his glory will be as a consuming fire that strikes death to the wicked. The ungodly will rush to hide themselves from his presence and call 
            upon the rocks to cover them.
            <btn id="clickable23" className="footnote">23 </btn>
            <Tooltip anchorSelect="#clickable23" className="footnote-size" clickable>Luke 23:30; 1 Thessalonians 4:15-17; Revelation 6:14-17; D&C 45:45-46; 88:95-98.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>Joseph revealed that Christ will come “down from God in heaven with dyed garments, ...  clothed in his glorious apparel, traveling in the greatness of 
            his strength.”  
            <btn id="clickable24" className="footnote">24 </btn>
            <Tooltip anchorSelect="#clickable24" className="footnote-size" clickable>D&C 133:46.</Tooltip>
            
            The revelation continues, “The Lord shall be red in his apparel, and his garments like him that treadeth the wine-vat ... And his voice shall be heard: 
            I have trodden the winepress alone … I have trampled them in my fury, and I did tread them in mine anger and their blood have I sprinkled upon my garments.”  
            <btn id="clickable25" className="footnote">25 </btn>
            <Tooltip anchorSelect="#clickable25" className="footnote-size" clickable>D&C 133:46, 48, 50-51.</Tooltip>
            
            Christ will “utter his voice, and all the ends of the earth shall hear it,”
            <btn id="clickable26" className="footnote">26 </btn>
            <Tooltip anchorSelect="#clickable26" className="footnote-size" clickable>D&C 45:49.</Tooltip>  
            
            saying: “Hearken, O ye nations of the earth and hear the words of that God who made you. O, ye nations of the earth, how often would I have gathered you together 
            as a hen gathereth her chickens under her wings, but ye would not!”
            <btn id="clickable27" className="footnote">27 </btn>
            <Tooltip anchorSelect="#clickable27" className="footnote-size" clickable>D&C 43:23-26.</Tooltip>
          </p>
        </div>

        <h2 className="headlinePadding">Christ Not Alone as He Descends</h2>

        <div className='paragraph'>
          <p>Christ will not appear alone. Joseph Smith revealed Christ saying, “I will reveal myself from heaven with power and great glory, with all the hosts thereof.”  
          <btn id="clickable28" className="footnote">28 </btn>
          <Tooltip anchorSelect="#clickable28" className="footnote-size" clickable>D&C 29:11.</Tooltip>
            
            These hosts include heavenly angels, the City of Enoch and its inhabitants, as well as the righteous on earth who are caught up to meet Christ. Among the myriad of 
            angels and personages that will accompany Christ in his descent to earth will be his Twelve Apostles at Jerusalem. Joseph revealed, “… the Twelve which were with 
            me in my ministry at Jerusalem, shall stand at my right hand at the day of my coming in a pillar of fire, being clothed with robes of righteousness, with crowns 
            upon their heads, in glory even as I am.”
            <btn id="clickable29" className="footnote">29 </btn>
            <Tooltip anchorSelect="#clickable29" className="footnote-size" clickable>D&C 29:12.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>The two prophets whose bodies were left in the streets of Jerusalem will also rise. “… the Spirit of life from God entered into them, and they stood upon their 
            feet; and great fear fell upon them which saw them. And they heard a great voice from heaven saying unto them, Come up hither. And they ascended up to heaven in 
            a cloud.”
            <btn id="clickable30" className="footnote">30 </btn>
            <Tooltip anchorSelect="#clickable30" className="footnote-size" clickable>Revelation 11:11-12.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Joseph revealed that the City of Enoch will join in the descent with the heavenly host. “Then shall thou and all they city meet them there, and we will receive 
            them into our bosom, and they shall see us; and we will fall upon their necks, and they shall fall upon our necks, and we will kiss each other.”
            <btn id="clickable31" className="footnote">31 </btn>
            <Tooltip anchorSelect="#clickable31" className="footnote-size" clickable>Moses 7:63.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>As Christ, the angels, resurrected beings, and the City of Enoch descend, the righteous dead on the earth will resurrect and also ascend skyward to meet them. 
            Joseph revealed, “And they who have slept in their graves shall come forth, for their graves shall be opened; and they also shall be caught up to meet him in the 
            midst of the pillar of heaven … all this by the voice of the sounding of the trump of the angel of God.”
            <btn id="clickable32" className="footnote">32 </btn>
            <Tooltip anchorSelect="#clickable32" className="footnote-size" clickable>D&C 88:94-98.</Tooltip> 
          </p>
        </div>

        <h2 className="headlinePadding">Earthquake on the Mount of Olives</h2>

        <div className='paragraph'>
          <p>As Christ descends on the Mount of Olives, and his feet touch the mountain, it will cleave in two causing an earthquake. Joseph revealed, “And then shall the Lord set his foot upon this mount, and it shall cleave in twain, and the earth shall tremble, and reel to and fro, and the heavens also shall shake.” 
          </p>
        </div>

        <div className='paragraph'>
          <p>At this point, the Jews who have not converted to Mormonism and who are not part of Zion in Jerusalem, will approach Christ and marvel at the wounds in his body 
            from his crucifixion. Old Testament prophet Zechariah wrote, “And one shall say unto him, What are these wounds in thine hands? Then he shall answer, 
            Those with which I was wounded in the house of my friends.”
            <btn id="clickable33" className="footnote">33 </btn>
            <Tooltip anchorSelect="#clickable33" className="footnote-size" clickable>Zechariah 13:6.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>Joseph added to this in a revelation. “And then shall the Jews look upon me and say: What are these wounds in thine hands and in thy feet? Then shall they know 
            that I am the Lord; for I will say unto them: These wounds are the wounds with which I was wounded in the house of my friends. I am he who was lifted up. I am 
            Jesus that was crucified.”
            <btn id="clickable34" className="footnote">34 </btn>
            <Tooltip anchorSelect="#clickable34" className="footnote-size" clickable>D&C 45:51-52.</Tooltip> 
          </p>
        </div>

        <h2 className="headlinePadding">Great Upheavals on the Earth</h2>

        <div className='paragraph'>
          <p>At Christ’s coming natural disasters will sweep the globe to destroy the remaining wicked. This will finish the job and cleanse the earth to make it a worthy 
            habitation for Christ’s kingdom during the Millennium. “And there shall be earthquakes also in divers places, and many desolations.”  
            <btn id="clickable35" className="footnote">35 </btn>
            <Tooltip anchorSelect="#clickable35" className="footnote-size" clickable>D&C 45:33.</Tooltip> 
            
            As the earth shakes and reels upon its axis, mountains will be levelled, valleys exalted, rough places made smooth, and the mighty deep driven back to the north 
            countries.
            <btn id="clickable36" className="footnote">36 </btn>
            <Tooltip anchorSelect="#clickable36" className="footnote-size" clickable>Isaiah 24:20; 40:4-5; Revelation 6:13-14; D&C 43:18; 45:33, 48; 49:23; 84:118; 88:87, 91; 109:74; 133:22-23.</Tooltip>  
          </p>
        </div>

        <div className='paragraph'>
          <p>This will cause both the topography and geography of the earth to transform into new land masses that will be inhabited during Christ’s Millennial reign. 
            The continents will be restored to their original location as they were at the earth’s creation.  
            <btn id="clickable37" className="footnote">37 </btn>
            <Tooltip anchorSelect="#clickable37" className="footnote-size" clickable>Isaiah 62:4; Revelation 6:13; D&C 88:87; 133:24.</Tooltip> 
            
            Also, creating great upheavals in the earth will be the return of Enoch’s city, which, according to Joseph Smith, was taken outside the earth’s atmosphere.
          </p>
        </div>

        <div className='paragraph'>
          <p>The earth will have finally received its rightful king.
          </p>
        </div>

        </div>

        <div className="chapterFooter">
          <Link to="/Chap12">Previous</Link>
          <Link to="/">Home</Link>
          <Link to="/Chap14">Next</Link>
        </div>

    </div>
  )
}

export default Chap13